import analysisNotifications from 'uf/analysis/epics/notifications';
import { combineEpics } from 'uf/base/epics';

export default combineEpics(
  {
    analysisNotifications,
  },
  'analysis',
);
